<div class="AmBannerCorporate" *ngIf="corporateRecognition && showBanner" [ngClass]="{'AmBannerCorporate-corporate': corporateRecognition && showBanner}"> <!-- TODO: Quitar todos los showBanner -->
  <div class="AmBannerCorporate-images" *ngIf="(corporateRecognition && corporateRecognition.logo && corporateRecognition.spid) || showBanner">
    <img alt="Aereomexico" class="AmBannerCorporate-image" src="./assets/images/logo-AMCorp.svg" />
    <div class="AmBannerCorporate-separator"></div>
    <img
      class="AmBannerCorporate-image"
      alt="Logo"
      [src]="corporateRecognition?.companyLogo"
      #imageCommpany
      (error)="onErrorImage($event, imageCommpany)"
      *ngIf="!showBanner"
    />
  </div>
  <div class="AmBannerCorporate-message">
    <span class="fs-22px lh-28px fw-regular" [innerHTML]="messageBanner | translate: { corp: (corporateRecognition && companyName) && !showBanner ? companyName : '' }"></span>
  </div>
</div>
